import { Form } from 'antd';
import { getRules } from './util';
import { getForm } from './util';

//form.item里面不能存在其他标签，所以用函数代替标签写法
const DynamicForm = (props) => {
    return (
        <Form.Item key={props.field_id} label={props.name} name={props.en_name} rules={getRules(props)}>
            {getForm(props)}
        </Form.Item>
    );
};
export default DynamicForm;
